export default __webpack_public_path__ + "c1f9bbce0753935956549a3d53b873cd.webp";